import { Component, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { BasePage } from "../../../shared/base.page";
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';


@Component({
    templateUrl: './invoices.page.html',
})

export class InvoicesPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;

    items: any[] = [

    ]

    StatusList: any[] = [
        { id: 1, title: "Created" },
        { id: 2, title: "Approved" },
        { id: 3, title: "Canceled" }
    ]


    constructor(public router: Router, serviceCaller: ServiceCaller) {
        super(serviceCaller);
    }


    onMenuItemClick(e) {
        switch (e.name) {
            case "reset":
                {
                    break;
                }
        }
    }

}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Companies/invoices.page.ts